import { required, email, max, min, min_value, max_value, numeric, between } from "@vee-validate/rules";
// import { extend } from "vee-validate";
import { configure, defineRule } from 'vee-validate';

import useDateTimeFormatter from "@/composables/formatDateTime.js";
const { formatDateUtcD, dateBetween, toUtcFormat } = useDateTimeFormatter();
import {emptyGuid} from '@/composables/miscellaneous.js'

defineRule('max', max);
defineRule('min', min);
defineRule('email', email);
defineRule('numeric', numeric);
defineRule('between', between);
defineRule('min_value', min_value);
defineRule('max_value', max_value);
defineRule('required', required);

defineRule('date_after', (value, [validFrom]) => {
  return value > validFrom;
});

defineRule('min_value', (value, [min]) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  return Number(value) >= Number(min);
});

defineRule('max_value', (value, [max]) => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  return Number(value) <= Number(max);
});

defineRule('date_between', (value, [min = "1200-01-01", max = "2050-12-31"]) => {
  if (value === null || value === undefined || value === "") {
    return false;
  }
  return dateBetween(value, min, max);
});

defineRule('double', (value) => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  // Assuming the rule checks for valid decimal format
  const regex = /^-?\d*(\.\d+)?$/;
  return regex.test(value);
})
defineRule('decimal', (value, [decimals = "*", separator = "."]) => {
  if (value === null || value === undefined || value === "") {
    return false;
  }
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value);
  }
  const regexPart = decimals === "*" ? "+" : `{1,${decimals}}`;
  const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);
  return regex.test(value);
});

defineRule('postalcode', (value) => {
  if (value === null || value === undefined || value === "") {
    return false;
  }
  const regex = /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i;
  return regex.test(value);
});

defineRule('unequal_Onbekend', (value) => {
  return value !== "Onbekend";
});


defineRule('guid', (value) => {
  const emptyGuid = '00000000-0000-0000-0000-000000000000'; // Adjust based on your empty GUID representation
  const correctSyntax = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return value && correctSyntax.test(value) && value !== emptyGuid;
});


// Configure messages
configure({
  generateMessage: (context ) => {
    switch (context.rule.name) {
      case 'date_after':
        return `$Veld moet groter zijn dan ${toUtcFormat(context.rule.params[0])}`;
      case 'alpha':
        return `Veld mag alleen letters bevatten`
      case 'required':
        return `Veld is verplicht`;
      case 'max':
        return `Veld mag niet groter zijn dan ${context.rule.params[0] ?? 0} karakters`;
      case 'min':
        return `Veld moet minimaal ${context.rule.params[0] ?? 0} karakters zijn`;
      case 'min_value':
        return `Veld moet minimaal ${context.rule.params[0] ?? 0} zijn`;
      case 'max_value':
        return `Veld mag maximaal ${context.rule.params[0] ?? 0} zijn`;
      case 'email':
        return `Veld moet een geldig e-mailadres zijn`;
      case 'numeric':
        return `Veld mag alleen cijfers bevatten`;
      case 'between':
        return `Veld mag alleen waarden bevatten tussen ${context.rule.params[0] ?? 0} en ${context.rule.params[1] ?? 0}`;
      case 'date_between':
        return `Veld moet liggen tussen ${formatDateUtcD(context.rule.params[0])} en ${formatDateUtcD(context.rule.params[1] )}`;
      case 'decimal':
        return `Veld mag maximaal ${context.rule.params[0] ?? 0} decimalen hebben`;
      case 'double':
        return `Veld moet een geldig decimaal zijn`;
      case 'postalcode':
        return `Geen geldige postcode`;
      case 'unequal_Onbekend':
        return `Onbekend is geen geldige waarde`;
      case 'guid':
        return `Veld is geen geldige Guid`;
      case 'housenumber':
        return `Huisletter mag niet groter zijn dan 1 karakters`;
      case 'houseletter':
        return `Huisletter mag niet groter zijn dan 1 karakters`
      default:
        return `Het veld is ongeldig.`;
    }
  }
});

// "alpha": "{_field_} mag alleen letters bevatten",
// "alpha_dash": "{_field_} mag alleen letters, nummers, en streepjes bevatten",
// "alpha_num": "{_field_} mag alleen letters en nummers bevatten",
// "alpha_spaces": "{_field_} mag alleen letters en spaties bevatten",
// "between": "{_field_} moet tussen {min} en {max} liggen",
// "confirmed": "{_field_} bevestiging komt niet overeen",
// "digits": "{_field_} moet een nummer zijn en exact {length} tekens bevatten",
// "dimensions": "{_field_} moet {width} pixels breed zijn en {height} pixels hoog",
// "email": "{_field_} moet een geldig e-mailadres zijn",
// "excluded": "{_field_} is ongeldig",
// "ext": "{_field_} moet een geldig bestand zijn",
// "image": "{_field_} moet een afbeelding zijn",
// "integer": "{_field_} moet een nummer zijn",
// "length": "{_field_} moet {length} karakters zijn",
// "max": "{_field_} mag niet groter zijn dan {length} karakters",
// "max_value": "{_field_} mag maximaal {max} zijn",
// "mimes": "{_field_} moet een geldig bestandstype hebben",
// "min": "{_field_} moet minimaal {length} karakters zijn",
// "min_value": "{_field_} moet minimaal {min} zijn",
// "numeric": "{_field_} mag alleen nummers bevatten",
// "oneOf": "{_field_} moet een geldige waarde zijn",
// "regex": "{_field_} formaat is ongeldig",
// "required": "{_field_} is verplicht",
// "required_if": "{_field_} is verplicht",
// "size": "{_field_} mag niet groter zijn dan {size}KB",
// "double": "{_field_} moet een geldige decimaal zijn"
